import { render, staticRenderFns } from "./NewTokenDialog.vue?vue&type=template&id=7b5f78e7"
import script from "./NewTokenDialog.vue?vue&type=script&lang=js"
export * from "./NewTokenDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports